/** Contato, navegação e a empresa por trás do site. Troque aqui, não nas seções. */
export const siteConfig = {
  /** Endereço público do site, sem barra no fim: liga o canonical e a imagem de compartilhamento. */
  siteUrl: 'https://www.vincdev.com.br',
  name: 'VincDev',
  fullName: 'VincDev Soluções em Tecnologia',
  tagline: 'Software sob medida para o seu negócio crescer.',
  company: {
    legalName: 'VincDev Soluções em Tecnologia LTDA',
    cnpj: '61.637.365/0001-16',
    /** Encarregado pelo tratamento de dados (art. 41 da LGPD), nomeado na política. */
    dataProtectionOfficer: 'Vinicios Bryam Campera',
  },
  contactEmail: 'developer@vincdev.com.br',
  /** WhatsApp em formato internacional, sem sinais; vazio esconde os botões. */
  whatsapp: '5545999496961',
  whatsappDisplay: '+55 (45) 99949-6961',
  /** Mensagem que já chega escrita quando o visitante abre a conversa. */
  whatsappMessage: 'Olá! Quero conversar sobre um projeto com a VincDev.',
  /** Assunto sugerido no e-mail de contato. */
  contactSubject: 'Quero conversar sobre um projeto',
  nav: [
    { label: 'Serviços', href: '/#servicos' },
    { label: 'Como trabalhamos', href: '/#como-trabalhamos' },
    { label: 'Cases', href: '/#cases' },
    { label: 'Sobre', href: '/#sobre' },
    { label: 'Contato', href: '/#contato' },
  ],
};

export function contactMailto(subject = siteConfig.contactSubject): string {
  return `mailto:${siteConfig.contactEmail}?subject=${encodeURIComponent(subject)}`;
}

export function whatsappLink(text = siteConfig.whatsappMessage): string | null {
  return siteConfig.whatsapp
    ? `https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent(text)}`
    : null;
}
